const initAnimation = () => {
    const $contactInfo = $(".contact-info");
    const $icons = $contactInfo.find(".animations");
    for (let index = 0; index < $icons.length; index++) {
        const $icon = $($icons[index]);
        const animationObject = $icon.data("anime");
        if (!animationObject) continue;
        animationObject.pause();
        animationObject.restart();
        animationObject.remove(".red-circle");

        const animationObject1 = $icon.data("anime1");
        if (!animationObject1) continue;
        animationObject1.pause();
        animationObject1.remove(".red-circle");
        $contactInfo.find(".sub-text").css({ opacity: 0 })
    }

    for (let index = 0; index < $icons.length; index++) {
        const nextIndex = index == $icons.length - 1 ? 0 : index + 1;
        const $icon = $($icons[index]);
        const $nextIcon = $($icons[nextIndex]);
        const $mainText = $icon.parent().find(".main-text");
        const $subText = $icon.parent().find(".sub-text");
        const circle = $icon.find(".red-circle")[0];
        const translateX = $icon.width() * 0.6

        if (!circle) continue;
        const animationObject = anime({
            targets: circle,
            direction: 'alternate',
            easing: 'cubicBezier(.5, .05, .1, .3)',
            duration: 500,
            loop: true,
            translateX: translateX * 0.1
        });
        $(circle).css({
            top: -($(circle).height() - $icon.height()) / 2,
            left: $mainText.width() * 0.7
        });

        $icon.data("anime", animationObject);
        const animationObject1 = anime({
            targets: circle,
            direction: 'alternate',
            easing: 'cubicBezier(.5, .05, .1, .3)',
            loop: false,
            //translateX: [0, $icon.width(), $icon.width() - 50],
            keyframes: [
                {
                    translateX: translateX,
                    duration: 1000,
                    scale: 1.5,
                },
                {
                    translateX: translateX - 50,
                    duration: 800,
                    scale: 1.5,
                },
                {
                    translateX: 0,
                    duration: 800,
                    scale: 1,
                },
            ],
            autoplay: false,

            update: function (anim) {
                if (anim.progress > 70) {
                    $subText.css({ opacity: 0 })
                };

                if (anim.progress > 20 && anim.progress < 70) {
                    $subText.css({ opacity: 1 })
                }
                if (anim.progress > 80) {
                    $nextIcon.data("anime1").play()
                }
            },
            complete: function () {
                $icon.data("anime").restart();
            }
        });
        $icon.data("anime1", animationObject1)
    }
    $($icons[0]).data("anime1").play()
}
const contact = () => {
    if (!$(".contact").length) return;
    initAnimation();
    let currentWidth = $(window).width();
    $(window).on("resize", function () {
        if ($(window).width() == currentWidth) return;
        currentWidth = $(window).width();
        initAnimation()
    })
}

module.exports = contact
